import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from "react";
import toast from "react-hot-toast";
import { translateBackendErrorCode } from "@jti/fe-common";
import { CasProfileApi } from "@jti/rest-api";
import { Toaster, useTranslations } from "@jti/ui";
import DiscountBlockMessage from "./DiscountBlockMessage";
import "./DiscountBlock.scss";
const TOO_MANY_REQUEST_STATUS_CODE = 429;
const DiscountBlock = ({ welcomeTitle, welcomeSubHeadline, welcomeText, successTitle, successText, successButtonLabel, successButtonUrl, requestLimitErrorPageTitle, requestLimitErrorPageText, requestLimitErrorPageButtonLabel, requestLimitErrorPageButtonUrl, buttonLabel, imageFileReference, imageSmallFileReference, backgroundImageFileReference, backgroundImageSmallFileReference, imageAlt, backgroundImageAlt, }) => {
    const [status, setStatus] = useState("welcome");
    const [pending, setPending] = useState(false);
    const { __ } = useTranslations();
    const contentData = useMemo(() => {
        const welcomeData = {
            description: welcomeText,
            title: welcomeTitle,
            buttonLabel,
            subHeadline: welcomeSubHeadline,
        };
        const successData = {
            title: successTitle,
            description: successText,
            buttonLabel: successButtonLabel,
        };
        const errorData = {
            title: requestLimitErrorPageTitle,
            description: requestLimitErrorPageText,
            buttonLabel: requestLimitErrorPageButtonLabel,
        };
        switch (status) {
            case "welcome":
                return welcomeData;
            case "success":
                return successData;
            case "error":
                return errorData;
            default:
                return welcomeData;
        }
    }, [
        status,
        welcomeText,
        welcomeTitle,
        welcomeSubHeadline,
        successTitle,
        successText,
        successButtonLabel,
        requestLimitErrorPageTitle,
        requestLimitErrorPageText,
        requestLimitErrorPageButtonLabel,
        buttonLabel,
    ]);
    const requestDiscount = async () => {
        setPending(true);
        try {
            await CasProfileApi.init().requestDiscount();
            setStatus("success");
        }
        catch (error) {
            setPending(false);
            if (error?.statusCode === TOO_MANY_REQUEST_STATUS_CODE) {
                return handleError();
            }
            const translatedError = translateBackendErrorCode(error?.error_code);
            toast.error(translatedError || error?.message || __("discount_block.error.message"));
        }
        setPending(false);
    };
    const handleError = () => {
        setStatus("error");
    };
    const onClickErrorButton = () => {
        if (requestLimitErrorPageButtonUrl) {
            window.location.href = requestLimitErrorPageButtonUrl;
        }
    };
    const onClickSuccessButton = () => {
        if (successButtonUrl) {
            window.location.href = successButtonUrl;
        }
    };
    const onButtonClick = () => {
        if (status === "welcome") {
            requestDiscount();
        }
        if (status === "error") {
            onClickErrorButton();
        }
        if (status === "success") {
            onClickSuccessButton();
        }
    };
    return (_jsxs("div", { className: "aem-discount-block__container", children: [_jsx(DiscountBlockMessage, { ...contentData, variant: status, pending: pending, onClick: onButtonClick, mobileBackgroundImage: backgroundImageSmallFileReference, backgroundImageAlt: backgroundImageAlt }), _jsx("div", { className: "aem-discount-block__image-wrapper", children: _jsxs("picture", { className: "aem-discount-block__picture", children: [_jsx("source", { media: "(max-width: 959px)", srcSet: imageSmallFileReference }), _jsx("source", { media: "(min-width: 960px)", srcSet: imageFileReference }), _jsx("img", { className: "aem-discount-block__image", src: imageFileReference, alt: imageAlt })] }) }), _jsx("img", { className: "aem-discount-block__background-image", src: backgroundImageFileReference, alt: backgroundImageAlt }), _jsx(Toaster, {})] }));
};
export default DiscountBlock;
//# sourceMappingURL=DiscountBlock.js.map